import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover, Tooltip } from 'antd';
import { FC, ReactNode, useState } from 'react';

interface IPhlebTooltipProps {
  text: ReactNode;
  children: ReactNode;
  /** Override breakpoint (default 768) */
  breakpoint?: number;
  /** Color for the info icon on mobile (default #8c8c8c) */
  iconColor?: string;
}

/**
 * Desktop: wraps children in a Tooltip (hover).
 * Mobile (<768px): appends a small "i" icon that opens a Popover on tap.
 */
export const PhlebTooltip: FC<IPhlebTooltipProps> = ({
  text,
  children,
  breakpoint = 768,
  iconColor = '#8c8c8c',
}) => {
  const [open, setOpen] = useState(false);
  const isMobile =
    typeof window !== 'undefined' && window.innerWidth < breakpoint;

  if (isMobile) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {children}
        <Popover
          content={
            <div style={{ maxWidth: 280, fontSize: 12, lineHeight: 1.5 }}>
              {text}
            </div>
          }
          trigger="click"
          visible={open}
          onVisibleChange={setOpen}
          placement="bottom"
        >
          <InfoCircleOutlined
            style={{
              fontSize: 12,
              color: iconColor,
              cursor: 'pointer',
              flexShrink: 0,
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </Popover>
      </span>
    );
  }

  return (
    <Tooltip
      title={
        <div style={{ maxWidth: 300, fontSize: 12, lineHeight: 1.5 }}>
          {text}
        </div>
      }
      placement="top"
      mouseEnterDelay={0.3}
    >
      <span style={{ cursor: 'help' }}>{children}</span>
    </Tooltip>
  );
};
